import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CatalogFile, PermissionDiffValidateResponse, RoleDiffValidateResponse } from '@models/authorization';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class ImportChangesService {
  private readonly url = `${environment.bffUrl}/authorization`;
  private readonly httpClient = inject(HttpClient);

  validate(catalog: CatalogFile): Observable<PermissionDiffValidateResponse | RoleDiffValidateResponse> {
    const catalogType = catalog.kind === 'RoleCatalog' ? 'role' : 'permission';
    return this.httpClient.post<PermissionDiffValidateResponse | RoleDiffValidateResponse>(
      `${this.url}/validate-${catalogType}-catalog`,
      catalog,
    );
  }

  approve(importId: string): Observable<void> {
    return this.httpClient.post<void>(`${this.url}/catalog-imports/${importId}`, undefined);
  }
}
